import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  fg: FormGroup;
  errorMessage: string;
  isAuth: boolean;

  constructor(
    private _authService: AuthService,
    private _router: Router,
    private _builder: FormBuilder
  ) {}

  ngOnInit(): void {
    const currentUser = this._authService.curentUserValue;
    if (currentUser) {
      this.isAuth = true;
    } else {
      this.isAuth = false;
    }
    this.fg = this._builder.group({
      email: ['', [Validators.required, Validators.email]],
      psd: ['', Validators.required],
    });
  }
  onSubmit() {
    if (this.isAuth) {
      this._authService.signOut();
    } else {
      const email = this.fg.get('email').value;
      const psd = this.fg.get('psd').value;
      this._authService.signIn(email, psd).subscribe(
        (data) => {
          this._router.navigate(['/editpage']);
        },
        (error) => {
          this.errorMessage = 'Password or email incorrect';
        }
      );
    }
  }
  toEditpage() {
    this._router.navigate(['editpage']);
  }

  // signIn(): void {
  //   this.authStatus = this._authService.signIn();
  //   this._router.navigate(['editpage']);
  // }

  // signOut(): void {
  //   this.authStatus = this._authService.signOut();
  // }
}
// u variable
// authStatus: boolean;
//ide u on init
  // this.authStatus = this._authService.isAuth;
